var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breakText" },
      [
        _c(
          "el-row",
          [
            _c("app-display", {
              class:
                _vm.compararImovelTransferencia &&
                _vm.compararImovelTransferencia.mudouDenominacao
                  ? "text"
                  : "",
              attrs: { label: "Denominação:", content: _vm.imovel.denominacao }
            }),
            _c("app-display", {
              class:
                _vm.compararImovelTransferencia &&
                _vm.compararImovelTransferencia.mudouMunicipio
                  ? "text"
                  : "",
              attrs: {
                label: "Município:",
                content: _vm.imovel.municipio ? _vm.imovel.municipio.nome : ""
              }
            }),
            _c("app-display", {
              class:
                _vm.compararImovelTransferencia &&
                _vm.compararImovelTransferencia.mudouArea
                  ? "text"
                  : "",
              attrs: {
                label: "Área:",
                content:
                  _vm.imovel.formattedValueArea !== "0,0000 hectare(s)"
                    ? _vm.getArea()
                    : ""
              }
            })
          ],
          1
        ),
        _c("info-matricula", { attrs: { imovel: _vm.imovel } }),
        _c(
          "app-collapse",
          { attrs: { title: "Dados do título" } },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c("app-display", {
                      class:
                        _vm.compararImovelTransferencia &&
                        _vm.compararImovelTransferencia
                          .mudouNomeBeneficiarioTitulo
                          ? "text"
                          : "",
                      attrs: {
                        label: "Nome do beneficiário:",
                        content: _vm.getValue(_vm.imovel.nomeBeneficiarioTitulo)
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51dad4cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51dad4cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/transferenciaDireitos/InformacoesImovelTransferencia.vue
// module id = null
// module chunks = 